<template>
  <div>
    <a-card
      :head-style="{ background: 'rgb(243, 243, 243)', fontSize: '14px' }"
      :body-style="{ textAlign: 'center' }"
    >
      <template #title>
        <div class="header">
          <div class="left"><SearchOutlined />搜索查询</div>
          <div class="right">
            <button @click="searchSupply">查询结果</button>
          </div>
        </div>
      </template>
      <div>
        <a-form :label-col="labelCol" :wrapper-col="wrapperCol" layout="inline">
          <a-form-item label="客户账号">
            <a-input
              placeholder="用户ID/账号"
              v-model:value="formState.username"
            ></a-input>
          </a-form-item>
          <a-form-item label="用户昵称">
            <a-input
              placeholder="用户昵称"
              v-model:value="formState.name"
            ></a-input>
          </a-form-item>

          <a-form-item label="注册时间">
            <a-date-picker
              placeholder="请选择时间"
              v-model:value="formState.time"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
            ></a-date-picker>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card
      :head-style="{ background: 'rgb(243, 243, 243)', fontSize: '14px' }"
      :body-style="{ padding: '0' }"
    >
      <template #title>
        <div class="header">
          <div class="left">
            <AlignLeftOutlined />
            数据列表
          </div>
          <div class="right">
            <button @click="exportData">导出数据</button>
          </div>
        </div>
      </template>
      <!-- table -->
      <a-table
        :dataSource="dataSource"
        :columns="columns"
        bordered
        :row-selection="rowSelection"
        :pagination="false"
        rowKey="id"
      >
        <template #supplierLevel="{ text, record, index }">
          {{
            record.supplierLevel == 0
              ? "普通会员"
              : record.supplierLevel == 1
              ? "黄金会员"
              : record.supplierLevel == 2
              ? "白金会员"
              : "钻石会员"
          }}
        </template>
        <template #city="{ text, record, index }">
          {{ formating(record.companyCity) }}
        </template>
        <template #seeTime="{ text, record, index }">
          <a-switch
            checked-children="开"
            un-checked-children="关"
            :checked="record.state"
            @click="changeBtn(record)"
          />
        </template>
        <template #operation="{ text, record, index }">
          <a-popover>
            <template #content>
              <p @click="seeDetail(record)">查看</p>
              <p style="color: #49d385" @click="edit(record)">编辑</p>
              <p style="color: #f36d69" @click="deleteSupply(record)">删除</p>
            </template>
            <span>操作</span>
          </a-popover>
        </template>
        <template #footer>
          <div class="header">
            <div class="left">
              <a-checkbox v-model="isChecked" @change="onChange"
                >全选</a-checkbox
              >
            </div>
            <div class="right">
              <df-pagination :model="pageObj"></df-pagination>
            </div>
          </div>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {
  SearchOutlined,
  AlignLeftOutlined,
  SmileOutlined,
} from "@ant-design/icons-vue";
import { notification } from "ant-design-vue";
import { computed, ref, unref, reactive, provide } from "vue";
import { useRouter } from "vue-router";
import supply from "@/axios/supply";
import { message } from "ant-design-vue";
let formating = (val) => {
  alert(val);
};
export default {
  components: {
    SearchOutlined,
    AlignLeftOutlined,
    SmileOutlined,
  },
  name: "newSupplyList",
  setup() {
    let router = useRouter();
    let formState = reactive({
      name: "",
      businessNo: "",
      time: "",
    });
    let isChecked = ref(false);

    //配置默认列
    const selectedRowKeys = ref([]);
    const onSelectChange = (changableRowKeys) => {
      selectedRowKeys.value = changableRowKeys;
    };
    /**
     * selected 当前是否选中全选
     * selectedRows 当前选中的内容
     * changeRows 数组
     */
    const rowSelection = computed(() => {
      return {
        selectedRowKeys: unref(selectedRowKeys),
        onChange: onSelectChange,
      };
    });
    let onChange = (e) => {
      if (e.target.checked === true) {
        isChecked.value = true;
        let id = dataSource.value.map((item) => item.id);
        let arr1 = [];
        arr1.push(id);
        selectedRowKeys.value = arr1[0];
      } else {
        isChecked.value = false;
        selectedRowKeys.value = [];
      }
    };
    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });
    let dataSource = ref([]);
    //查询供应列表
    let searchSupply = () => {
      let params = {
        offset: 0,
        page: pageObj.value.page,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
        name: formState.name,
        businessNo: formState.businessNo,
        createBeginTime: formState.time,
        username: formState.username,
      };
      supply.supplyList(params).then((res) => {
        dataSource.value = res.data;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
      });
    };
    searchSupply();
    //修改拜访
    const changeBtn = (row) => {
      let params = {
        lid: row.id,
        type: row.state == 1 ? 0 : 1,
      };
      supply.toggleSupply(params).then(() => {
        searchSupply();

        notification.open({
          message: "修改成功",
          icon: <SmileOutlined style="color: #108ee9" />,
        });
      });
    };
    let seeDetail = (record) => {
      router.push({
        name: "newSupplyDetail",
        query: {
          id: record.id,
        },
      });
    };
    let exportData = () => {
      supply.getData();
    };
    let deleteSupply = (record) => {
      let params = {
        businessNo: record.businessNo,
      };
      supply
        .removeSupply(params)
        .then((res) => {
          console.log(res);
          searchSupply();
          message.success("删除成功");
        })
        .catch((err) => {
          message.fail("删除失败");
        });
    };
    let edit = (record) => {
      router.push({
        path: "/shop/addSupply",
        query: {
          id: record.id,
        },
      });
    };
    let formating = (val) => {
      let reg = /\:/g;
      let str = val.replace(reg, "");
      let reg1 = /\""/g;
      let str1 = str.replace(reg1, "");
      let reg2 = /\d/g;
      let str2 = str1.replace(reg2, "");
      let reg3 = /,/g;
      let str3 = str2.replace(reg3, "");
      let reg4 = /""/g;
      let str4 = str3.replace(reg4, "");
      let reg5 = /{"||"}/g;
      let str5 = str4.replace(reg5, "");
      let reg6 = /"}/g;
      let str6 = str5.replace(reg6, "");
      return str6;
    };
    const pageChange = (page) => {
      pageObj.value.page = page;
      searchSupply();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      searchSupply();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    return {
      formating,
      edit,
      deleteSupply,
      exportData,
      seeDetail,
      formState,
      onChange,
      selectedRowKeys,
      isChecked,
      pageObj,
      changeBtn,
      dataSource,
      searchSupply,
      rowSelection,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      columns: [
        {
          title: "公司名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "用户账号",
          dataIndex: "username",
          key: "username",
        },
        {
          title: "所在地",
          slots: {
            customRender: "city",
          },
        },
        {
          title: "等级",
          dataIndex: "supplierLevel",
          key: "supplierLevel",
          slots: {
            customRender: "supplierLevel",
          },
        },
        {
          title: "业务权限",
          dataIndex: "address",
          key: "address",
        },
        {
          title: "账户状态",
          dataIndex: "address",
          key: "address",
          slots: {
            customRender: "seeTime",
          },
        },
        {
          title: "操作",
          slots: {
            customRender: "operation",
          },
        },
      ],
    };
  },
};
</script>

<style lang='scss'>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
button {
  border: 1px solid #ccc;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer;
}
.ant-checkbox-checked .ant-checkbox-inner,
.ant-checkbox-indeterminate .ant-checkbox-inner {
  background-color: #1bba79;
  border: 1px solid #ccc;
}
.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background-color: #1bba79;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: " ";
}
p {
  cursor: pointer;
}
</style>